/**
 * The enum used for increase or decrease indentation of a block
 * Used by setIndentation API
 */
// eslint-disable-next-line etc/no-const-enum
export const enum Indentation {
    /**
     * Increase indentation
     */
    Increase,

    /**
     * Decrease indentation
     */
    Decrease,
}
